export default "__VITE_ASSET__CnmLFj$t__"